import type React from 'react';
import { Trans } from 'react-i18next';
import type { AppSsrFetchedDataType } from '../../../server/AppSsr';
import MainLayout from '../../layout/MainLayout/MainLayout';

interface ServicesProps {
  ssrFetchedData: AppSsrFetchedDataType;
}

const Services: React.FC<ServicesProps> = ({ ssrFetchedData }) => (
  <MainLayout
    categories={false}
    search={false}
    navbar
    footer
    ssrFetchedData={ssrFetchedData}
  >
    <div className="flex size-full min-h-full flex-col items-center justify-center">
      <span className="my-48 p-3 text-lg font-semibold">
        <Trans i18nKey="static.beta.wip_page_message">
          <span className="text-sky-600">
            <a
              data-test-id="discord-link"
              href="https://discord.com/channels/1194693419923157142/1194693419923157145"
              target="_blank"
              rel="noreferrer"
            >
              &nbsp;
            </a>
          </span>
        </Trans>
      </span>
    </div>
  </MainLayout>
);

export default Services;
